export const REGEX_VALID_NUMBER = {
  INTEGER: new RegExp("^\\-?\\d*$"),
  POSITIVE_INTEGER: new RegExp("^\\d*$"),
  DOUBLE: new RegExp("^\\-?(\\d+\\.)?\\d*$"),
  POSITIVE_DOUBLE: new RegExp("^(\\d+\\.)?\\d*$")
};

export const REGEX_EXTRACT_TAG_CONTENT = new RegExp("<.*>([^<>]*)<.*>");



// WEBPACK FOOTER //
// ./src/constants/regex.js